import React from 'react';
import PropTypes from 'prop-types';
import './PageSubTitle.scss';

const PageSubTitle = ({title, ...props}) => (
  <div className="page-subtitle" {...props}>
    <h3>{title}</h3>
  </div>
);

PageSubTitle.propTypes = {
  title: PropTypes.string.isRequired,
};

export default PageSubTitle;
